import { render } from "./GameConfig.vue?vue&type=template&id=5ffde0bf&scoped=true"
import script from "./GameConfig.vue?vue&type=script&lang=js"
export * from "./GameConfig.vue?vue&type=script&lang=js"

import "./GameConfig.vue?vue&type=style&index=0&id=5ffde0bf&scoped=true&lang=scss"

import exportComponent from "/Users/lucky02/Desktop/project/hw_businessManagement/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffde0bf"]])

export default __exports__